export const actions = {
  resetValue: '[Settings] RESET_VALUE',
  updateItem: '[Settings] UPDATE_ITEM'
};

export const resetValue = data => (dispatch) => {
  dispatch({
    type: actions.resetValue,
    payload: data
  });
};

export const updateItem = data => (dispatch) => {
  dispatch({
    type: actions.updateItem,
    payload: data
  });
};



// WEBPACK FOOTER //
// ./src/actions/settings.js